export default __webpack_public_path__ + "static/media/fff2.898501e3.png";